import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "top-text" }
const _hoisted_4 = { class: "content__drop-zone__add-file__text__buttons" }
const _hoisted_5 = { class: "content__drop-zone__add-file__text" }
const _hoisted_6 = { class: "content__drop-zone__add-file__icon" }
const _hoisted_7 = { class: "content__drop-zone__add-file__text--disabled" }

import { ref, toRefs } from 'vue'
import InputFileDropBase from './InputFileDropBase.vue'
import { useI18n } from 'vue-i18n'
import IconUpload from '@/design-system/assets/icons/IconUpload.vue'
import ButtonOutline from '@/design-system/atoms/buttons/ButtonOutline.vue'
import IconUploadFile from '@/design-system/assets/icons/IconUploadFile.vue'
import IconUploadDirectory from '@/design-system/assets/icons/IconUploadDirectory.vue'

interface EMITS {
  (e: 'files', val: File[])
  (e: 'items', val: DataTransferItem[])
}

export default /*@__PURE__*/_defineComponent({
  __name: 'InputFileDrop',
  props: {
  disabled: { type: Boolean, default: false }
},
  emits: ["files", "items"],
  setup(__props, { emit: __emit }) {

const props = __props
const { disabled } = toRefs(props)
const emits = __emit
const { t } = useI18n()
const dirInput = ref<HTMLInputElement | null>(null)
const fileInput = ref<HTMLInputElement | null>(null)

function clickFileInput(event?: Event, preventDefault?: boolean) {
  if (event && preventDefault) event.preventDefault() // Prevent space bar scrolling
  if (fileInput.value) fileInput.value.click()
}

function onInputChange(event: Event) {
  const target = event.target as HTMLInputElement
  const files = target.files
  if (files) {
    emits('files', Array.from(files))
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(InputFileDropBase, {
      disabled: _unref(disabled),
      "overlay-background-color": "#d5d7f6",
      onFilesDropped: _cache[0] || (_cache[0] = ($event: any) => (emits('files', $event))),
      onItemsDropped: _cache[1] || (_cache[1] = ($event: any) => (emits('items', $event))),
      onKeydown: [
        _withKeys(clickFileInput, ["enter"]),
        _cache[2] || (_cache[2] = _withKeys((event) => clickFileInput(event, true), ["space"]))
      ]
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass([
              'content__drop-zone__add-file__text',
              { 'content__drop-zone__add-file__text--disabled': _unref(disabled) }
            ])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(IconUpload, {
                class: _normalizeClass(['icon', { 'icon--disabled': _unref(disabled) }])
              }, null, 8, ["class"]),
              _createElementVNode("span", null, _toDisplayString(_unref(t)('general__data__files-drop-here')), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", {
                style: _normalizeStyle({ pointerEvents: _unref(disabled) ? 'none' : 'auto' })
              }, [
                _createElementVNode("input", {
                  ref_key: "fileInput",
                  ref: fileInput,
                  class: "hidden-input",
                  type: "file",
                  multiple: "",
                  onChange: onInputChange
                }, null, 544),
                _createVNode(ButtonOutline, {
                  buttonText: _unref(t)('general__data__files-add'),
                  size: "small",
                  disabled: _unref(disabled)
                }, {
                  left: _withCtx(() => [
                    _createVNode(IconUploadFile)
                  ]),
                  _: 1
                }, 8, ["buttonText", "disabled"])
              ], 4),
              _createElementVNode("span", null, _toDisplayString(_unref(t)('general__text__or').toLowerCase()), 1),
              _createElementVNode("label", {
                style: _normalizeStyle({ pointerEvents: _unref(disabled) ? 'none' : 'auto' })
              }, [
                _createElementVNode("input", {
                  ref_key: "dirInput",
                  ref: dirInput,
                  class: "hidden-input",
                  type: "file",
                  webkitdirectory: "",
                  directory: "",
                  multiple: "",
                  onChange: onInputChange
                }, null, 544),
                _createVNode(ButtonOutline, {
                  buttonText: _unref(t)('general__data__directory-add'),
                  size: "small",
                  disabled: _unref(disabled)
                }, {
                  left: _withCtx(() => [
                    _createVNode(IconUploadDirectory)
                  ]),
                  _: 1
                }, 8, ["buttonText", "disabled"])
              ], 4)
            ])
          ], 2)
        ])
      ]),
      active: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('general__data__file-drop')), 1)
      ]),
      disabled: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(IconUpload)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, _toDisplayString(_unref(t)('general__text__files-drop-disabled')), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["disabled"])
  ]))
}
}

})